// extracted by mini-css-extract-plugin
export default {"removeTagBtn":"app-react-components-TagSelector-TagSelector-module__remove-tag-btn"};